import { useEffect, useState } from "react";
import FormField from "./FormField";
import Text from "./Text";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import { ProgressSpinner } from "primereact/progressspinner";
import useAuthHttp from "../hooks/useAuthHttp";
import { useQuery } from "@tanstack/react-query";

export interface ICripto {
    id: string;
    symbol: string;
    available_exchanges: string[];
    currency_base: string;
    currency_quote: string;
    date_add: string | null;
    code: string;
}

export interface ICriptoSelected {
    id: string;
    currency_base: string;
    code: string;
}

interface ICriptoList {
    currency_list: ICripto[];
}

export interface ICriptoSearchSelectorProps {
    selected: ICriptoSelected|undefined;
    select: (currency: ICriptoSelected|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const CriptoSearchSelector = (props: ICriptoSearchSelectorProps) => {
    const [searchQueryDebounce, setSearchQueryDebounce] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState<string>("");

    const authHttp = useAuthHttp();
    const criptoQuery = useQuery({
        queryKey: ["currency", searchQueryDebounce],
        queryFn: async () => {
            if (!searchQueryDebounce) {
                return { currency_list: [] };
            }
            
            return await authHttp.doGet<ICriptoList>("/cripto?search=" + searchQueryDebounce);
        }
    });
    useEffect(() => {
        const timeout = setTimeout(async () => {
            setSearchQueryDebounce(searchQuery);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQuery]);

    return (
        <FormField
            id="currencySearchSelector"
            label="Moeda"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selected?.currency_base ?? searchQuery}
                    className="w-full pr-5"
                    placeholder="Procure pelo código"
                    invalid={props.hasError}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                    }}
                />
                
                {
                    props.selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.select(undefined);
                            setSearchQuery("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                criptoQuery.isPending && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!criptoQuery.data?.currency_list.length && !props.selected && !criptoQuery.isPending && searchQuery && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            criptoQuery.data.currency_list.map(cripto => {
                                return (
                                    <li key={cripto.id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.select(cripto);
                                                setSearchQuery("");
                                            }}
                                        >
                                            {cripto.currency_base}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default CriptoSearchSelector;